<div class="filter-pill" *ngIf="filterName && filterValue">
  <div class="filter-text">
    <span class="filter-name">{{ filterName }}: </span>
    <span>{{ filterValue }}</span>
  </div>
  <i class="icon-x" (click)="onCancelFilter()"></i>
</div>